import axios from "axios";

import { eskalationsLevel, header, host, localCache } from "./globalVariables";
import { getCleanUsers, getKacheln } from "./networkFunctions";

export function formatText(text) {
   const parts = text.split(/(\*\*[^*]+\*\*|__[^_]+__)/g);

   return parts.map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
         return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      if (part.startsWith("__") && part.endsWith("__")) {
         return <u key={index}>{part.slice(2, -2)}</u>;
      }
      return part;
   });
}
